<div *ngIf="show" class="warning-notice" [class.zoom-out]="hide && applyZoomOut" [class.error]="isError">
  <div class="warning-content">
    <app-st-icon [filled]="true"
                 [color]="isError ? '#CB2A2F' : '#A35200'"
                 class="warning-icon"
                 [name]="isError ? 'dangerous' : 'warning'"
                 [bold]="true"></app-st-icon>
    <div class="warning-text">
      <div *ngIf="titleTmpl" class="warning-title">
        <ng-container [ngTemplateOutlet]="titleTmpl"></ng-container>
      </div>
      <div *ngIf="messageTmpl" class="warning-message">
        <ng-container [ngTemplateOutlet]="messageTmpl"></ng-container>
      </div>
      <div *ngIf="actionTmpl" class="warning-action">
        <ng-container [ngTemplateOutlet]="actionTmpl"></ng-container>
      </div>
    </div>
  </div>
</div>
